export default __webpack_public_path__ + "static/media/step2.91a70038.png";